import { useCallback, useState } from 'react';
import { GeneratePassword as generatePassword } from 'js-generate-password';

import { GeneratePassword, Options } from '../constants';

type PasswordOptions = {
    [GeneratePassword.LENGTH]: number;
    [GeneratePassword.OPTIONS]: Options[];
};

const defaultData = {
    [GeneratePassword.LENGTH]: 16,
    [GeneratePassword.OPTIONS]: [Options.LOWERCASE, Options.UPPERCASE, Options.SYMBOLS, Options.NUMBERS],
} as const satisfies PasswordOptions;

export const useGeneratePassword = (onSave: (password: string) => void) => {
    const [data, setData] = useState<PasswordOptions>(defaultData);

    const generateAndReplace = useCallback(() => {
        const generatedPassword = generatePassword({
            length: data[GeneratePassword.LENGTH],
            uppercase: data[GeneratePassword.OPTIONS].includes(Options.UPPERCASE),
            lowercase: data[GeneratePassword.OPTIONS].includes(Options.LOWERCASE),
            symbols: data[GeneratePassword.OPTIONS].includes(Options.SYMBOLS),
            // This is weird, why should we decrease the entropy?
            exclude: '(){}[],:;@?\\/|_.+-<>~\'"`',
            numbers: data[GeneratePassword.OPTIONS].includes(Options.NUMBERS),
            minLengthLowercase: 1,
            minLengthUppercase: 1,
            minLengthNumbers: 1,
            minLengthSymbols: 1,
        });

        onSave(generatedPassword);
    }, [data, onSave]);

    return {
        data,
        setData,
        generateAndReplace,
    };
};
